import { PDFManagerFactory } from 'pdftron';
import { DocumentTypes } from 'types';

type GrayscaleViewer = {
  enableGrayscaleMode: () => void;
  disableGrayscaleMode: () => void;
};

export function applyGrayscaleMode(docViewer: GrayscaleViewer | null | undefined, grayscaleMode: boolean) {
  if (!docViewer) return;
  if (grayscaleMode) docViewer.enableGrayscaleMode();
  else docViewer.disableGrayscaleMode();
}

/** Apply the live grayscale flag to one panel's viewer. The other panel applies when its own viewer is created. */
export function applyGrayscaleToDocument(documentType: DocumentTypes, grayscaleMode: boolean) {
  applyGrayscaleMode(PDFManagerFactory.getPDFDocManager()?.getInstance(documentType)?.docViewer, grayscaleMode);
}
